import { render, staticRenderFns } from "./universitiesList.vue?vue&type=template&id=2387e320&scoped=true&"
import script from "./universitiesList.vue?vue&type=script&lang=js&"
export * from "./universitiesList.vue?vue&type=script&lang=js&"
import style0 from "./universitiesList.vue?vue&type=style&index=0&id=2387e320&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387e320",
  null
  
)

export default component.exports